<template>
  <div class="home page">
    <div class="banner">
      <svg
        class="name"
        xmlns="http://www.w3.org/2000/svg"
        width="736"
        height="405"
        viewBox="0 0 736 405"
      >
        <g
          fill="none"
          fill-rule="evenodd"
          font-family="Selima"
          font-size="150"
          letter-spacing="2.269"
        >
          <text fill="#FFD602">
            <tspan x="91.343" y="171">Aniket</tspan>
          </text>
          <text fill="#FFD602">
            <tspan x="296.143" y="343">Sharma</tspan>
          </text>
        </g>
      </svg>

      <img class="profile card" src="../assets/pp.jpeg" />
    </div>
    <p>
      <span>I ❤️ building new products and doing 🧪 experiments. I am 👾 developer by day, 👨‍🔬 researcher by night and 🎨 designer in free time.</span>
    </p>
    <div class="resume__banner">
      <div class="stripes resume__pattern"></div>
      <h1>RESUME</h1>
    </div>
    <a
      href="http://aniket965.github.io/resume/re.pdf"
      target="_blank"
      class="nostyle btn elevated-btn"
      style=" margin-bottom: 10vh; margin-top:2vh;"
    >DOWNLOAD</a>
    <div class="center-child full-width">
      <div class="aniket965__divider"></div>
    </div>

    <div style="min-height:100vh;">
      <div class="project__showcase">
        <h1 class="center-child colorful-text">Recents Projects</h1>
      </div>
      <div class="center-child full-width">
        <div class="aniket965--grid c3g">
          <VideoCard
            title="SwalJawab"
            backgroundUrl="sw.jpeg"
            uri="https://swal-jawab.web.app/"
          />
          <VideoCard
            title="Celestini Project India"
            backgroundUrl="celestini.png"
            uri="https://www.youtube.com/watch?v=Toaz0wVky0A"
          />
          <VideoCard
            title="QuickSpeech"
            backgroundUrl="quickspeech.jpg"
            uri="https://www.youtube.com/watch?v=5d8RA3fBAa0"
          />
          <VideoCard
            title="Censored Chrome"
            backgroundUrl="censored-chrome.jpeg"
            uri="https://www.youtube.com/watch?v=pF0a1R0KoK8"
          />

        </div>
      </div>
    </div>
    <div class="aniket965__divider"></div>
  </div>
</template>

<script>
import VideoCard from "../components/VideoCard";
export default {
  name: "HomePage",
  components: {
    VideoCard
  },
  beforeMount() {
    var metaThemeColor = document.querySelector("meta[name=theme-color]");
    metaThemeColor.setAttribute("content", "#FFD600");
  },
  methods: {
    track() {
      this.$ga.page("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.project__showcase {
  width: 100%;
  padding: 3rem 0;
  min-height: 10rem;
  h1 {
    font-family: "Satisfy", cursive;
    font-size: var(--banner-size);
    color: var(--purple);
  }
}

.home {
  display: flex;
  margin-top: 100px;
  flex-direction: column;
  //   justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: auto;
  }
  p {
    margin-top: -10vh;
    max-width: 450px;
    width: 70vw;
    text-align: justify;
    font-size: 1.2rem;
    line-height: 3.3rem;
    span {
      background: #ededed;
      display: inline;
      font-family: "Satisfy", cursive;
      font-size: 1.8rem;
    }
  }
}
.banner {
  width: fit-content;
  margin-left: -10vw;
  .name {
    height: auto;
    width: 500px;
    max-width: 78vw;
    display: block;
    position: relative;
  }
  .profile {
    width: 50vw;
    height: 50vw;
    max-width: 300px;
    max-height: 300px;
    margin-right: -10vw;
    border-radius: 50%;
    margin-top: -10vh;
    float: right;
  }
}
.resume__banner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 10vh;
  h1 {
    margin-left: -5rem;
    background: linear-gradient(45deg, #18dd6a, var(--purple));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 400% 400%;
    -webkit-animation: brandingAnim 2s ease-out infinite;
    animation: brandingAnim 2s ease-out infinite;
    font-weight: bolder;
    font-size: var(--banner-size);
  }
  .resume__pattern {
    justify-self: center;
    align-self: center;
    height: 200px;
    width: 300px;
    border-radius: 20px;
  }
}
.colorful-text {
   background: linear-gradient(45deg, #dd18bc, var(--purple));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 400% 400%;
    -webkit-animation: brandingAnim 2s ease-out infinite;
    animation: brandingAnim 2s ease-out infinite;
}

@media screen and (max-width: 720px) {
  .home p {
    font-size: 1rem;
    margin-top: -5vh;
    line-height: 2.3rem;
  }
  .home p span {
    font-size: 1.2rem;
  }
  .project__showcase {
  h1 {
    text-align: center;
  }
}

  .resume__banner {
    grid-template-columns: 1fr;
    h1 {
      margin-left: 0;
      text-align: center;
    }
    .resume__pattern {
      height: 120px;
    }
  }
}
</style>


